module.exports = __webpack_public_path__ + "static/mary-kay-about-2-84e2ba05dd1726ab30b1cfb3c81b23df.png";